import {BaseModel} from "../base/base.model";
import {RoleTypes, Roles} from "../roles";

export class UsersModel extends BaseModel{
    id: number;
    name: string = '';
    email: string = '';
    active: number = 0;
    role: RoleTypes;
    company_ids: number[] = [];
    created_at: string = '';
    permissions: string[] = [];
    access_token: string = null;
    smtp_server: string = null;
    smtp_user: string = null;
    smtp_pass: string = null;
    smtp_port: number = 0;
    smtp_method: string = null;
    extension_number: string = null;
    slack_id:string = "";
    slack_name:string = "";
}






// WEBPACK FOOTER //
// ./src/app/models/users/users.model.ts